module.exports = __webpack_public_path__ + "static/media/gray-avatar.72261863.svg";